import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios"

import { notify } from "shared/ui/Notifications/notify"

/**
 * Creates and configures the main Axios instance with default headers
 * @returns {AxiosInstance} Configured axios instance
 */
const axiosInstance = (): AxiosInstance => {
  return axios.create({
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Accept: "application/json",
    },
  })
}

// Create the axios instance
const useThisAxios: AxiosInstance = axiosInstance()

// Add response interceptor with proper error handling
useThisAxios.interceptors.response.use(
  (response: AxiosResponse): AxiosResponse => response,
  (error: AxiosError): Promise<never> => {
    // Handle different types of axios errors
    if (error.response) {
      // Server responded with error status
      notify.error(
        error.name || "Server Error",
        error.message || "An error occurred with the server response"
      )
    } else if (error.request) {
      // Request was made but no response received
      notify.error(
        "Network Error",
        "Unable to connect to the server. Please check your internet connection."
      )
    } else {
      // Something else happened
      notify.error(
        error.name || "Request Error",
        error.message || "An unexpected error occurred"
      )
    }

    // Re-throw the error to maintain the rejection chain
    return Promise.reject(error)
  }
)

export default useThisAxios
